import { apiRoute, authHeader, handleResponse } from '../helpers'

export const statsService = {
  getAll,
  getTotals,
  getTotalsRange,
  getHistorical,
  getSystem,
  getUptime,
  getUptimePdf,
  getSystemPdf,
  getHistoricalPdf,
  getDateRangePdf,
  getTotalsPdf
}

function getAll (filter, datefrom, dateto) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/' + datefrom + '/' + dateto, requestOptions).then(handleResponse)
}

function getTotals (filter) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/totals', requestOptions).then(handleResponse)
}

function getTotalsRange (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/totalsDateRange' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getHistorical (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/historical' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getSystem (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/system' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getUptime (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/uptime' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getUptimePdf (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/uptimePdf' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getSystemPdf (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/systemPdf' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getHistoricalPdf (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/historicalPdf' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

function getDateRangePdf (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/dateRangePdf' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}
function getTotalsPdf (filter, dateRangeStart, dateRangeEnd) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(apiRoute() + '/api/v1/stats/' + filter + '/totalsPdf' + '/' + dateRangeStart + '/' + dateRangeEnd, requestOptions).then(handleResponse)
}

// '/:site/totalsDateRange/:datefrom/:dateto' historical
